import { defineMessages } from "react-intl";
import classNames from "classnames";

import Icon from "../../../Utils/Icon";

const ContributionsDatavizThemeTooltip = props => {
  const { theme } = props;
  const { parentTheme, reactionsCount, contributionsCount } = theme;

  const t = props.formatMessage;
  const contributionsLabel = t(intlMessages.contributions, { count: contributionsCount });
  const reactionsLabel = t(intlMessages.reactions, { count: reactionsCount });

  const iconClassNames = classNames([theme.icon, "align-middle"]);

  return (
    <div className="dataviz-tooltip-theme-tooltip sujet">
      <div className="dataviz-box-top-label dataviz-tooltip-theme-label">
        <div
          className="theme"
          style={{ backgroundColor: theme.color, color: theme.textColor }}
        >
          {parentTheme.name}
        </div>
      </div>

      <div className="d-flex align-items-center margin-bottom-xs">
        <div
          className="dataviz-tooltip-theme-tooltip-icon icon margin-right-xxs text-center rounded-circle"
          style={{ backgroundColor: theme.color, color: theme.textColor }}
        >
          <Icon className={iconClassNames} />
        </div>

        <div className="description col">{theme.name}</div>
      </div>

      <div className="d-flex text-small">
        <ul className="d-flex list-unstyled padding-none margin-bottom-none">
          <li className="flex-1 text-truncate margin-right-xs">
            <span className="text-primary margin-right-xxs nowrap">
              <Icon className="icon-pencil align-middle margin-right-xxs" />
              {contributionsCount}
            </span>
            {contributionsLabel}
          </li>

          <li className="flex-1 text-truncate">
            <span className="text-primary margin-right-xxs nowrap">
              <Icon className="dataviz-reactions align-middle margin-right-xxs" />
              {reactionsCount}
            </span>
            {reactionsLabel}
          </li>
        </ul>
      </div>
    </div>
  );
};

export default ContributionsDatavizThemeTooltip;

const intlMessages = defineMessages({
  contributions: {
    id: "contributions.dataviz.themeTooltip.contributions",
    defaultMessage: "{count, plural, one { contribution } other { contributions }}"
  },
  reactions: {
    id: "contributions.dataviz.themeTooltip.reactions",
    defaultMessage: "{count, plural, one { réaction } other { réactions }}"
  }
});
